import "./toggleSwitch.css"
import PropTypes from "prop-types";

const ToggleSwitch = ({isChecked, isDisabled = false, onChange}) => {
  return <label className="flex items-center cursor-pointer">
    <div className="relative">
      <input type="checkbox" className="sr-only" checked={isChecked} onChange={onChange} disabled={isDisabled}/>
      <div className={`w-10 h-4 ${isChecked ? "bg-green-200" : "bg-gray-200"} rounded-full shadow-inner`}/>
      <div className="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"/>
    </div>
  </label>
}

ToggleSwitch.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}

export default ToggleSwitch
